<template>
  <section class="block-navbar-internal">
    <filters-roles v-if="showFilters"></filters-roles>
    <div class="container-fluid" v-bind:class="{ 'filters-roles-coupling' : showFilters }">
      <div class="btn-group">
        <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          <ejs-tooltip content="Menú" ref="tooltip" :position="'TopCenter'">
           <div class="option-menu">
              <div class="hamburger-menu">
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
              </div>
            </div>
          </ejs-tooltip>
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <router-link v-if="$validPermission('CUMP')" to="/procesos" class="dropdown-item">
            {{ $t('navbarInternal.processes') }}
          </router-link>
          <button v-if="$validPermission('RAD')" v-on:click="toggleSidebarClick('Radar', 'radar-index')"
                  type="button" class="dropdown-item">{{ $t('navbarInternal.radar') }}
          </button>
          <router-link v-if="$validPermission('REP')" to="/reportes" class="dropdown-item">
            {{ $t('navbarInternal.reports') }}
          </router-link>
          <router-link v-if="$validPermission('BUS')" to="/buscador" class="dropdown-item">
            {{ $t('navbarInternal.search') }}
          </router-link>
          <router-link v-if="$validPermission('CLI')" to="/clientes" class="dropdown-item">
            {{ $t('navbarInternal.customers') }}
          </router-link>
          <router-link v-if="$validPermission('USU')" to="/usuarios" class="dropdown-item">
            {{ $t('navbarInternal.users') }}
          </router-link>
          <router-link v-if="$validPermission('CLI-CLIPRO')" to="/procesos-estructurador"
                       class="dropdown-item">{{ $t('navbarInternal.processesManage') }}
          </router-link>
          <router-link v-if="$validPermission('ASNNORM')" to="/administrar-asuntos-normativos"
                       class="dropdown-item">{{ $t('navbarInternal.regulatoryAffairs') }}
          </router-link>
          <router-link v-if="$validPermission('NORM')" to="/normas" class="dropdown-item">
            {{ $t('navbarInternal.rules') }}
          </router-link>
          <router-link v-if="$validPermission('CLI-CLIPRO')" to="/estructurador-diagnostico"
                       class="dropdown-item">{{ $t('navbarInternal.diagnosis') }}
          </router-link>
          <router-link v-if="$validPermission('TOPIC') && canProfileUse(profile_for_topics)"
                       :to="{ name: 'structuring-topic-subtopic'}"
                       class="dropdown-item">
            {{ $t('navbarInternal.topicsSubtopics') }}
          </router-link>
          <router-link
              v-if="$validPermission('REPORT_STR') && canProfileUse(profile_for_report_structuring)"
              :to="{ name: 'structuring-detail-report-process'}"
              class="dropdown-item">
            {{ $t('navbarInternal.reportStructuring') }}
          </router-link>
          <router-link
              :to="{ name: 'reporte-estadistica-cumplimientos'}"
              class="dropdown-item">
            {{ $t('navbarInternal.monthlyStatistics') }}
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: 'navbar-internal',
  props: {
    showFiltersProp: {
      default: true,
    }
  },
  data() {
    return {
      showFilters: true,
      role: undefined,
      profile_for_topics: [
        'Abogado',
        'Estructurador'
      ],
      profile_for_report_structuring: [
        'Estructurador'
      ]
    }
  },
  created: function () {
    this.showFilters = this.showFiltersProp;
  },
  mounted() {
    this.role = this.$store.getters['moduleAvatar/avatar'].role
    this.initNavbarInternal();
  },
  methods: {
    canProfileUse(profiles) {
      return profiles.includes(this.role);
    },
    initNavbarInternal: function () {
      if (this.role === 'Estructurador'
          ||
          (
              this.$router.currentRoute.name === 'processes-detail' ||
              this.$router.currentRoute.name === 'processes-detail-compliance'
          )
      ) {
        this.showFilters = false;
      }
    },
    toggleSidebarClick: function (title, component) {
      Vue.prototype.$eventHub.$emit('toggleSidebarClick', title, component);
    },
    onClickFilterRoles: function (arrayFilters) {
      this.$parent.onClickFilterRoles(arrayFilters);
    },
  },
}
</script>
